import { Helmet } from "react-helmet";
import { CheckoutComponentChatAttibutesType } from "../../types/builder";

const Facebook: React.FC<
  Pick<CheckoutComponentChatAttibutesType, "accountId">
> = ({ accountId }) => {
  return (
    <>
      <Helmet>
        <script>
          {`
            var chatbox = document.getElementById('fb-customer-chat');
            chatbox.setAttribute("page_id", "${accountId}");
            chatbox.setAttribute("attribution", "biz_inbox");
          `}
        </script>

        <script>
          {`
              window.fbAsyncInit = function() {
                FB.init({
                  xfbml            : true,
                  version          : 'v14.0'
                });
              };

              (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
                fjs.parentNode.insertBefore(js, fjs);
              }(document, 'script', 'facebook-jssdk'));
          `}
        </script>
      </Helmet>
    </>
  );
};

export default Facebook;
